angular.module('pe4h').controller('Legal', function($scope, configuration, $state, $stateParams) {
	$scope.standAlone = $state.params.standAlone;
	console.log($scope.standAlone);
});